import SEO from "../components/SEO";
import QuickContactBanner from "../components/QuickContactBanner";

export default function CSRPage() {
  const csrBadges = [
    {
      name: "Webbureau Odense CO2",
      img: "https://assets.auxodev.dk/assets/f0baa3a2-6eb6-4b57-8f55-7b5fb1f2d6b7/webbureau-odense-co2.png",
      url: "https://toemrermesterjacob.dk/csr/"
    },
    {
      name: "Miljøvenlig Pakning",
      img: "https://assets.auxodev.dk/assets/f0baa3a2-6eb6-4b57-8f55-7b5fb1f2d6b7/miljoe-pakning-badge-100x100-2.png",
      url: "https://toemrermesterjacob.dk/csr/"
    },
    {
      name: "Reklamer nej tak",
      img: "https://assets.auxodev.dk/assets/f0baa3a2-6eb6-4b57-8f55-7b5fb1f2d6b7/reklamer-nej-tak-1.png",
      url: "https://toemrermesterjacob.dk/csr/"
    },
    {
      name: "Plastik i havet",
      img: "https://assets.auxodev.dk/assets/f0baa3a2-6eb6-4b57-8f55-7b5fb1f2d6b7/plastik-i-havet-badge-100.png",
      url: "https://toemrermesterjacob.dk/csr/"
    },
    {
      name: "Plastik nej tak",
      img: "https://assets.auxodev.dk/assets/f0baa3a2-6eb6-4b57-8f55-7b5fb1f2d6b7/plastik-nej-tak-100x100-1.png",
      url: "https://plastiknejtak.dk/virksomheder/"
    },
    {
      name: "Bæredygtig virksomhed",
      img: "https://assets.auxodev.dk/assets/f0baa3a2-6eb6-4b57-8f55-7b5fb1f2d6b7/baeredygtig-virksomhed-badge-100-1.png",
      url: "https://xn--bredygtig-virksomhed-i0b.dk/"
    },
    {
      name: "Sikker nethandel",
      img: "https://assets.auxodev.dk/assets/f0baa3a2-6eb6-4b57-8f55-7b5fb1f2d6b7/sikker-nethandel-badge-100-png-1.webp",
      url: "https://sikker-nethandel.dk/"
    },
    {
      name: "Miljøvenlige produkter",
      img: "https://assets.auxodev.dk/assets/f0baa3a2-6eb6-4b57-8f55-7b5fb1f2d6b7/miljoevenlige-produkter-badge-100-1.png",
      url: "https://xn--miljvenlige-produkter-tfc.dk/"
    },
    {
      name: "Miljørigtig kørsel",
      img: "https://assets.auxodev.dk/assets/f0baa3a2-6eb6-4b57-8f55-7b5fb1f2d6b7/miljoerigtig-koersel-badge-100-1.png",
      url: "https://xn--miljrigtig-krsel-oxbi.dk/"
    },
    {
      name: "Teknologisk udvikling",
      img: "https://assets.auxodev.dk/assets/f0baa3a2-6eb6-4b57-8f55-7b5fb1f2d6b7/teknologisk-udvikling-badge-100-1.png",
      url: "https://teknologisk-udvikling.dk/"
    },
    {
      name: "Online møder",
      img: "https://assets.auxodev.dk/assets/f0baa3a2-6eb6-4b57-8f55-7b5fb1f2d6b7/online-moeder-badge-100-png.webp",
      url: "https://xn--online-mder-ngb.dk/"
    },
    {
      name: "Undgå madspild",
      img: "https://assets.auxodev.dk/assets/f0baa3a2-6eb6-4b57-8f55-7b5fb1f2d6b7/undgaa-madspild-badge-100-png.webp",
      url: "https://xn--undg-madspild-sfb.dk/"
    },
    {
      name: "Grønne investeringer",
      img: "https://assets.auxodev.dk/assets/f0baa3a2-6eb6-4b57-8f55-7b5fb1f2d6b7/groenne-investeringer-badge-100.png",
      url: "https://xn--grnne-investeringer-w7b.dk/"
    },
    {
      name: "Affald i naturen",
      img: "https://assets.auxodev.dk/assets/f0baa3a2-6eb6-4b57-8f55-7b5fb1f2d6b7/affald-i-naturen-badge-100-png.webp",
      url: "https://affald-i-naturen.dk/"
    },
    {
      name: "Truede dyrearter",
      img: "https://assets.auxodev.dk/assets/f0baa3a2-6eb6-4b57-8f55-7b5fb1f2d6b7/truede-dyrearter-badge-100-png.webp",
      url: "https://truede-dyrearter.dk/"
    },
    {
      name: "Vilde blomster",
      img: "https://assets.auxodev.dk/assets/f0baa3a2-6eb6-4b57-8f55-7b5fb1f2d6b7/vilde-blomster-badge-100-png.webp",
      url: "https://vilde-blomster.dk/"
    },
    {
      name: "CO2 udledning",
      img: "https://assets.auxodev.dk/assets/f0baa3a2-6eb6-4b57-8f55-7b5fb1f2d6b7/co2-udledning-badge-100.png",
      url: "https://co2-udledning.dk/"
    },
    {
      name: "Sortering af affald",
      img: "https://assets.auxodev.dk/assets/f0baa3a2-6eb6-4b57-8f55-7b5fb1f2d6b7/sortering-af-affald-badge-100.png",
      url: "https://sortering-af-affald.dk/"
    }
  ];

  return (
    <>
      <SEO
        title="CSR - Tømrermester Jacob"
        description="Vi støtter bl.a. op om: Bæredygtighed, miljøinitiativer og lokalsamfundet."
        ogTitle="CSR - Tømrermester Jacob"
        ogDescription="Vi støtter bl.a. op om:"
      />

      {/* Hero */}
      <section className="bg-stone-100/60 border-b border-stone-200 py-12 lg:py-16">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center space-x-2 px-3 py-1 rounded-full bg-emerald-100 text-emerald-900 text-xs font-semibold uppercase tracking-wider mb-4">
            <i className="fa-solid fa-leaf text-emerald-700" aria-hidden="true"></i>
            <span>Samfundsansvar & Miljø</span>
          </div>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-stone-900 mb-4">
            CSR & Vi støtter
          </h1>
          <p className="text-base sm:text-lg text-stone-600 max-w-2xl mx-auto leading-relaxed">
            Hos Tømrermester Jacob tager vi ansvar for vores omgivelser og bakker op om bæredygtige og velgørende initiativer.
          </p>
        </div>
      </section>

      {/* Badges Section */}
      <section className="py-16 sm:py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl sm:text-3xl font-bold text-stone-900 tracking-tight text-center mb-10">
            Vi støtter bl.a. op om:
          </h2>

          <div className="py-10 px-6 bg-stone-50 rounded-xl border border-stone-200 text-center flex items-center justify-center">
            <span className="text-stone-400 font-semibold text-sm sm:text-base tracking-widest uppercase">
              LOGO KOMMER SNART
            </span>
          </div>
        </div>
      </section>

      <QuickContactBanner />
    </>
  );
}
